import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = ["aria-label"]
const _hoisted_3 = ["id", "checked", "value"]
const _hoisted_4 = ["for"]

import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { Icon } from '../../Atoms';


export default /*@__PURE__*/_defineComponent({
  __name: 'FilterWindow',
  props: {
    isFilterOpen: { type: Boolean },
    isMobile: { type: Boolean }
  },
  emits: ['setItemChecked', 'closeFilter'],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n();

const props = __props;

const emits = __emit;

const closeFilters = (e) => {
  e.preventDefault();
  emits('closeFilter');
};

const checkItems = [
  {
    id: props.isMobile ? 'filterDestinations' : 'filterDestinations_mobile',
    value: 'destinations',
    checked: true,
  },
  {
    id: props.isMobile ? 'filterPorts' : 'filterPorts_mobile',
    value: 'ports',
    checked: false,
  },
  {
    id: props.isMobile ? 'filterRoutes' : 'filterRoutes_mobile',
    value: 'routes',
    checked: false,
  },
];

const getCheckedIconText = (item: string) => {
  switch (item) {
    case 'destinations':
      return { icon: 'mapPin', text: t('Show all destinations') };
    case 'ports':
      return { icon: 'anchor', text: t('Show all ports') };
    default:
      return { icon: 'routes', text: t('Show all routes') };
  }
};


return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["filterWindow", {
      mobileFilterWindow:_ctx.isMobile,
      modalExpanded: _ctx.isFilterOpen
    }])
  }, [
    _createElementVNode("form", null, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(Icon), { "icon-name": "filter" }),
        _createElementVNode("h3", null, _toDisplayString(_ctx.$t('Filter')), 1),
        _createElementVNode("button", {
          class: "mobileExpandBtn",
          "aria-label": _ctx.$t('Close filters'),
          onClick: closeFilters
        }, [
          _createVNode(_unref(Icon), { "icon-name": "close" })
        ], 8, _hoisted_2)
      ]),
      _createElementVNode("fieldset", null, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(checkItems, (item, index) => {
          return _createElementVNode("div", {
            key: index,
            class: "inputWrapper"
          }, [
            _createElementVNode("input", {
              id: item.id,
              checked: item.checked,
              type: "checkbox",
              name: "filter",
              value: item.value,
              onChange: _cache[0] || (_cache[0] = (e) => _ctx.$emit('setItemChecked', e))
            }, null, 40, _hoisted_3),
            _createElementVNode("label", {
              for: item.id
            }, [
              _createVNode(_unref(Icon), {
                "icon-name": getCheckedIconText(item.value).icon
              }, null, 8, ["icon-name"]),
              _createTextVNode(" " + _toDisplayString(getCheckedIconText(item.value).text), 1)
            ], 8, _hoisted_4)
          ])
        }), 64))
      ])
    ])
  ], 2)), [
    [_vShow, _ctx.isFilterOpen]
  ])
}
}

})